import { useEffect } from "react";
import { getCookie, setCookie } from "@litres/utils";
import debounce from "lodash/debounce";
const useHorizontalScroll = (
  scrollContainerRef: React.RefObject<HTMLDivElement>
) => {
  const cookieName = "lower-menu-horizontal-scroll";

  useEffect(() => {
    // Восстанавливаем позицию скролла из куки после монтирования компонента
    const savedScrollPosition = parseFloat(getCookie(cookieName) || "");
    if (!isNaN(savedScrollPosition)) {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollLeft = savedScrollPosition;
      }
    }
  }, [cookieName]);

  const handleScroll = debounce(() => {
    // Обработчик события скролла
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      // Сохраняем позицию скролла в куки
      setCookie(cookieName, `${scrollLeft}`);
    }
  }, 300);

  return {
    scrollContainerRef,
    handleScroll,
  };
};

export default useHorizontalScroll;
